import React, { useRef } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import './CategoriesList.css';

function CategoriesList({ categories, selectedCategory, setSelectedCategory }) {
  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  return (
    <div className="categories-wrapper">
      <button className="scroll-btn left" onClick={scrollLeft}>
        <LeftOutlined  className='categories-wrapper-icon'/>
      </button>

      <div className="categories-container" ref={scrollContainerRef}>
        {categories.map((subject) => (
          <div
            key={subject.id}
            className={`category-item ${selectedCategory === subject.id ? 'active' : ''}`}
            onClick={() => subject.name !== 'Coming Soon' && setSelectedCategory(subject.id)} // Pass subject ID
          >
            {subject.name}
          </div>
        ))}
      </div>

      <button className="scroll-btn right" onClick={scrollRight}>
        <RightOutlined className='categories-wrapper-icon'/>
      </button>
    </div>
  );
}

export default CategoriesList;